import { Injectable, inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { Location } from '@angular/common';

import { AuthenticationService } from '~/core/services/authentication.service';
import { CompanyStore } from '../store/company.store';
import { URLS } from '~/core/constants/constants';
import { isDesktop } from '../helpers/device-utils';

@Injectable({
  providedIn: 'root',
})
export class RegisterMobileGuard implements CanActivate {
  private router = inject(Router);
  protected location = inject(Location);
  protected authenticationService = inject(AuthenticationService);
  protected companyStore = inject(CompanyStore);

  constructor() {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const canGo = !isDesktop();

    if (!canGo) {
      this.authenticationService.setAffiliated(JSON.stringify({ id: next.queryParams.affiliate_id }));
      this.authenticationService.setExternalAffiliate(next.queryParams.external_affiliate_id);
      this.authenticationService.setExternalAffiliateTracker(next.queryParams.external_affiliate_tracker);
      this.authenticationService.setReferrer(next.queryParams.rp);
      this.authenticationService.setExternalParams(next.queryParams);
      // INFO: Agora é possível compartilhar o link de registro para abrir a partir da tela de cassino mesmo que a tela de início seja a diferente de cassino (ex.: /casino/register?params=value)
      let navigateTo = '';
      if (next.queryParams.redirectTo) {
        navigateTo = next.queryParams.redirectTo.includes(URLS.CASINO_LIVE)
          ? URLS.CASINO_LIVE
          : next.queryParams.redirectTo.includes(URLS.CASINO)
            ? URLS.CASINO
            : '';
      }
      this.location.replaceState(state.url);
      void this.authenticationService.openRegisterScreen(this.location);
      void this.router.navigate([navigateTo], { skipLocationChange: true });

      return false;
    } else {
      await this.waitForCompany();
      return true;
    }
  }

  private async waitForCompany(): Promise<any> {
    if (Object.keys(this.companyStore.configSignal()).length) {
      return this.companyStore.configSignal();
    }

    try {
      return await firstValueFrom(this.companyStore.companyObservable());
    } catch (err) {
      console.error(err);
      return {};
    }
  }
}
